import React from 'react';
import {Provider} from "react-redux";
import {persistor, store} from "./redux/store";
import {PersistGate} from "redux-persist/integration/react";
import RootNavigation from "./pages/RootNavigation";
import AuthProvider from "./redux/features/auth/AuthProvider";
import SessionAnalytics from "./components/analytics/SessionAnalytics";

function App() {
    return (
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <RootNavigation/>
                    {/* WatchUserLocation removed — web is read-only */}
                    <AuthProvider/>
                    <SessionAnalytics/>
                </PersistGate>
            </Provider>
    );
}

export default App;
